import _bindInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/bind';
import classNames from 'classnames/bind';
import React from 'react';
import LottieLoadingWhite from './ic_Loading_white.json.js';
import '../../../hooks/useCopy.js';
import 'react-dom';
import 'react-use';
import '../../../constants/bottomNavigationBar.js';
import '../../../constants/global.js';
import '@babel/runtime-corejs3/helpers/slicedToArray';
import useLottie from '../../../hooks/useLottie.js';
import styles from './ButtonLoading.module.scss.js';

var cx = _bindInstanceProperty(classNames).call(classNames, styles);
var ButtonLoading = function ButtonLoading(_ref) {
  var width = _ref.width,
    height = _ref.height;
  var $loading = useLottie('buttonloading', LottieLoadingWhite, {
    loop: true,
    autoplay: true
  });
  return /*#__PURE__*/React.createElement("span", {
    className: cx('loading')
  }, /*#__PURE__*/React.createElement("div", {
    ref: $loading,
    style: {
      width: width,
      height: height,
      color: 'inherit'
    }
  }), /*#__PURE__*/React.createElement("span", {
    className: "blind"
  }, "\uB85C\uB529\uC911"));
};

export { ButtonLoading as default };
